module.exports = __webpack_public_path__ + "img/256-georgia.40c9e78d.svg";